export class InvalidOtpException extends Error {
  constructor(message) {
    super(message);
  }
}